import { useQuery } from "@tanstack/react-query";
import { getParticipantListTemplateForOrder, getParticipantListTemplateWithSignedLink } from "./participantListApi";

export interface UseOrderParticipantListTemplateOptions {
  readonly signedLinkToken?: string;
}

export const useOrderParticipantListTemplate = (
  orderId: string,
  options: UseOrderParticipantListTemplateOptions = {},
) => {
  const signedLinkToken = options?.signedLinkToken;
  const { data, isLoading } = useQuery({
    queryKey: signedLinkToken
      ? ["orders", orderId, "participant-list-template", signedLinkToken]
      : ["orders", orderId, "participant-list-template"],
    queryFn: ({ signal }) =>
      signedLinkToken
        ? getParticipantListTemplateWithSignedLink(orderId, signedLinkToken, signal)
        : getParticipantListTemplateForOrder(orderId, signal),
  });
  return {
    template: data,
    isLoading,
  };
};
